<div class="d-block d-lg-none">
  <fgb-page-header [pageTitle]="'faq.page.title'" [backButtonLink]="'/'" [showBalance]="false" [showQr]="false"></fgb-page-header>
</div>
<fgb-banner [title]="'faq.page.title' | translate"></fgb-banner>
<div class="container pb-5 pb-lg-0">
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
